export default "__VITE_ASSET__fe44939c__"